import request from "@/utils/request";
import qs from "qs";

/**
 * 新增-编辑类目
 * @param params
 * @returns {*}
 */
export function editCategory(params) {
  return request.post("/category/editCategory", qs.stringify(params));
}

/**
 * 查询类目树
 * @param params
 * @returns {*}
 */
export function getCategoryTree(params) {
  return request({
    url: "/category/getCategoryTree",
    method: "get",
    params
  });
}

/**
 * 查询类目树
 * @param params
 * @returns {*}
 */
export function getCascadeCategory(params) {
  return request({
    url: "/category/getCascadeCategory",
    method: "get",
    params
  });
}
